import { SectionHeaderCellProps } from '../../types';

const DetailsSectionCell = ({ _customRowProps }: SectionHeaderCellProps) => {
  return <div>Details</div>;
};

export default DetailsSectionCell;
